<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import http from "@/http";

export default defineComponent({
  name: "KindergardenView",
  data() {
    return {
      loading: false,
      dataList: [],
      totalElements: 0,
      totalPages: null,
      size: 15,
      page: 1,
      boards: [],
      workTypes: {
        "NEW_CONSTRUCTION": "Yangi qurilish",
        "PERFECT_REPAIR": "Mukammal ta'mir",
        "RECONSTRUCTION": "Rekonstruktsiya"
      },
      form: {
        board_id: null,
      },
      rules: {
        board_id: [
          {
            required: true,
            message: "Tashabbuslar doskasini tanlang!",
            trigger: "change",
          },
        ],
      },
    }
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    }
  },
  methods: {
    getBoards() {
      this.loading = true;
      http({url: `api/v1/boards`, params: {type: 'KINDERGARDEN', status: 1}})
          .then(({data}) => {
            this.boards = data?.boards;
            this.form.board_id = data?.boards[0].id;
            this.getKindergardens()
          })
          .catch((err) => {
            ElMessage.error(
                err?.response?.data?.message || `Hatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            this.loading = false;
          });
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, size: val},
          })
          .then(() => {
            this.getKindergardens();
          })
          .catch(() => {
          });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          })
          .then(() => {
            this.getKindergardens();
          })
          .catch(() => {
          });
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/kindergardens/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getKindergardens();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },
    onChangeBoard() {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, page: this.page},
          })
          .then(() => {
            this.getKindergardens();
          })
          .catch(() => {
          });
    },
    getKindergardens() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
          ? parseInt(this.$route.query.size || "")
          : this.size;

      this.$http
          .get(`api/v1/kindergardens`, {
            params: {
              board_id: this.form.board_id,
              district_id: null,
              region_id: null,
              search: null,
              limit: this.size,
              offset: (this.page - 1) * this.size,
            },
          })
          .then(({data}) => {
            this.dataList = data?.data;
            this.totalElements = data?.count;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    downloadExcel() {
      this.loading = true;
      this.$http
          .get(`api/v1/kindergardens/excel/export`, {
            responseType: "blob",
            params: {
              board_id: this.form.board_id,
            },
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    indexMethod(index) {
      return index + (this.currentPage - 1) * this.size + 1
    }
  },
  mounted() {
    this.getBoards();
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-select size="large"
                   v-model="form.board_id"
                   placeholder="Boardni tanlang"
                   @change="onChangeBoard"
                   clearable
                   style="min-width: 320px">
          <el-option
              v-for="board in boards"
              :key="board.id"
              :value="board.id"
              :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
          />
        </el-select>
      </div>
      <div style="display: flex;gap:5px">
        <el-button
            class="upload-demo"
            type="warning"
            @click="downloadExcel"
        >
          <img
              style="margin-right: 5px;"
              alt="Yuklash"
              src="@/assets/images/icons/download.svg"
          />
          Yuklash
        </el-button>
        <router-link to="kindergarden/add" class="el-button el-button--primary">
          Qo'shish
        </router-link>
      </div>
    </div>
    <el-table
        :data="dataList"
        class="table"
        border
        height="calc(100vh - 235px)"
    >
      <el-table-column type="index" :index="indexMethod" width="80" label="#"/>
      <el-table-column prop="organization" label="Tashkilot" min-width="280"/>
      <el-table-column prop="initial_value" label="Dastlabki qiymat" min-width="180"/>
      <el-table-column prop="power" label="Obyektning quvvati" min-width="180"/>
      <el-table-column prop="technical_position" label="Texnik holati" min-width="130"/>
      <el-table-column prop="type_of_work" label="Bajarilgan ish turi" min-width="180">
        <template v-slot="scope">
          {{ workTypes[scope.row.type_of_work] }}
        </template>
      </el-table-column>
      <el-table-column prop="last_repaired_year" min-width="140" label="So'ngi ta'mir yili"/>
      <el-table-column prop="region" label="Viloyat" min-width="220"/>
      <el-table-column prop="district" label="Tuman" min-width="180"/>
      <el-table-column prop="quarter" label="Manzili" min-width="180"/>
      <el-table-column prop="location" label="Lakatsiya" min-width="180"/>
      <el-table-column prop="description" label="Loyiha mazmuni" min-width="180"/>
      <el-table-column fixed="right" label="" width="200" align="center">
        <template #default="scope">
          <el-button
              type="primary"
              size="small"
              @click="
              $router.push({
                name: 'KindergardenFormEdit',
                params: { id: scope.row.id },
              })
            "
          >Tahrirlash
          </el-button>
          <el-button
              type="danger"
              size="small"
              @click="onClickDelete(scope.row.id)"
          >
            O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.el-button--primary {
  text-decoration: none;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
